(()=>{'use strict';
const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
const set=(id,v)=>{const e=document.getElementById(id);if(e)e.textContent=v};

const foundersPricing={
  '7D':{
    pro:{regular:'€11.99',price:'€8.99',duration:'7-day Performance Pass',badge:'25% Founders Saving',copy:'Give NVL one week with your PC. Scan it, optimise it, benchmark it — and keep the wins.',bottomTitle:'One week. One personalised performance pass.',bottomCopy:'A low-risk way to let the AI Smart Optimiser work on your machine.'},
    max:null
  },
  '30D':{
    pro:{regular:'€25.99',price:'€18.99',duration:'30-day access',badge:'Most Popular · 27% Founders Saving',copy:'Let NVL build a personalised optimisation plan for your PC — then prove what actually helped.',bottomTitle:'30 days to optimise, re-test and refine.',bottomCopy:'Stay covered while Fortnite, drivers and Windows change.'},
    max:{regular:'€54.99',price:'€39.99',duration:'30-day access',copy:'AI analyses your PC. A real NVL performance specialist helps finish the advanced work.',bottomTitle:'You do not just get more settings.',bottomCopy:"You get NVL's software intelligence plus a human performance specialist."}
  },
  'LIFETIME':{
    pro:{regular:'€79.99',price:'€59.99',duration:'Lifetime access',badge:'25% Founders Saving',copy:'Own the optimiser. Come back whenever your PC, drivers, Windows or Fortnite changes.',bottomTitle:'Buy once. Keep the optimiser.',bottomCopy:'Re-scan and re-optimise whenever your setup changes.'},
    max:{regular:'€129.99',price:'€99.99',duration:'Lifetime access',copy:'The complete NVL experience permanently — plus one custom BIOS optimisation session with NVL staff.',bottomTitle:'Full NVL access. No renewal clock.',bottomCopy:'Includes the advanced MAX layer and one included custom BIOS session.'}
  }
};

function renderFoundersPricing(key){
  const data=foundersPricing[key]; if(!data)return;
  $$('[data-duration]').forEach(x=>x.classList.toggle('active',x.dataset.duration===key));

  const pro=data.pro;
  set('v13-pro-regular',pro.regular);set('v13-pro-price',pro.price);set('v12-pro-duration',pro.duration);
  set('v13-pro-badge',pro.badge);set('v13-pro-copy',pro.copy);set('v13-pro-bottom-title',pro.bottomTitle);set('v13-pro-bottom-copy',pro.bottomCopy);

  const max=data.max, maxCard=$('#v13-max-card'), maxPriceBlock=$('#v13-max-price-block'), maxUnavailable=$('#v13-max-unavailable'), maxFeatures=$('#v13-max-features'), maxProof=$('#v13-max-proof'), maxButton=$('#v13-max-button');
  if(!max){
    if(maxCard)maxCard.classList.add('is-unavailable');
    if(maxPriceBlock)maxPriceBlock.hidden=true;
    if(maxUnavailable)maxUnavailable.hidden=false;
    if(maxFeatures)maxFeatures.hidden=true;
    if(maxProof)maxProof.hidden=true;
    if(maxButton){maxButton.setAttribute('aria-disabled','true');maxButton.classList.add('is-disabled');maxButton.textContent='MAX starts at 30 days';}
  }else{
    if(maxCard)maxCard.classList.remove('is-unavailable');
    if(maxPriceBlock)maxPriceBlock.hidden=false;
    if(maxUnavailable)maxUnavailable.hidden=true;
    if(maxFeatures)maxFeatures.hidden=false;
    if(maxProof)maxProof.hidden=false;
    if(maxButton){maxButton.removeAttribute('aria-disabled');maxButton.classList.remove('is-disabled');maxButton.textContent='Choose MAX →';}
    set('v13-max-regular',max.regular);set('v13-max-price',max.price);set('v12-max-duration',max.duration);
    set('v13-max-copy',max.copy);set('v13-max-bottom-title',max.bottomTitle);set('v13-max-bottom-copy',max.bottomCopy);
  }
}

$$('[data-duration]').forEach(b=>b.addEventListener('click',()=>renderFoundersPricing(b.dataset.duration)));
renderFoundersPricing('30D');
})();